import { IRmOp } from "interface/rm/op";
import { useTranslation } from "react-i18next";
import { lastTimes } from "components/utils/option";
import { useBaseSubmitForm } from "./service";
import Select from "components/select";
import { timeFormat } from "components/utils/comm";
import LodInfRow from "components/rows/lodRow";
import TableRow from "components/rows/tableRow";
import Cell from "components/rows/cell";
import RmNmSelect from "components/select/rm/rmNo";
import Radio from "components/rows/radio";

type IProps = {
  baseInf: IRmOp | undefined;
  formTyp: "create" | "update" | "read";
  formId: string;
};

export default function BaseInfForm({ baseInf, formTyp, formId }: IProps) {
  const { t } = useTranslation();
  const dataTyp =
    formTyp === "read" || (formTyp === "create" && !!baseInf?.opRgSeq)
      ? "R"
      : "C";
  const isUpdateAble = formTyp === "update" ? "true" : "false";

  const { onBaseSubmit } = useBaseSubmitForm();

  let lastTimesDft = lastTimes.find((time) => {
    return time.code === timeFormat(baseInf?.latChkOutTi ?? "");
  });

  return (
    <>
      <form id={formId} data-type={formTyp} onSubmit={onBaseSubmit}>
        <table>
          <tbody>
            <LodInfRow />
            <TableRow title={t("row_ttl_rm_op_inf")}>
              <ul>
                {baseInf?.rmNm && (
                  <li>
                    <Cell
                      label={t("lbl_rm_nm")}
                      value={baseInf?.rmNm ?? ""}
                      dataTyp="R"
                    />
                  </li>
                )}
                {!baseInf?.rmNm && (
                  <li>
                    <label
                      htmlFor={formTyp === "create" ? "dot" : ""}
                      data-dot="true"
                    >
                      {t("lbl_rm_nm")}
                    </label>
                    <RmNmSelect defaultValue={undefined} dataTyp={dataTyp} />
                  </li>
                )}
                <li hidden={!baseInf?.opRgSeq}>
                  <label htmlFor="">{t("lbl_op_rg_seq")}</label>
                  <input
                    type="text"
                    data-type="R"
                    value={baseInf?.opRgSeq}
                    readOnly
                  />
                </li>
                <li>
                  <label
                    htmlFor={formTyp === "create" && !baseInf ? "dot" : ""}
                  >
                    {t("lbl_lat_out_ti")}
                  </label>

                  <Select
                    options={lastTimes}
                    name={"latChkOutTi"}
                    styles="bg-white border-1"
                    defaultValue={lastTimesDft}
                    dataTyp={dataTyp}
                    isUpdateAble={isUpdateAble === "true"}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_brkf")}</label>
                  <div className="flex">
                    <Radio
                      label={t("included_y")}
                      id={"Y"}
                      name={"brkfInYn"}
                      dataTyp={dataTyp}
                      updateAble={isUpdateAble}
                      checked={baseInf ? baseInf.brkfInYn === "Y" : true}
                    />
                    <Radio
                      label={t("included_n")}
                      id={"N"}
                      name={"brkfInYn"}
                      dataTyp={dataTyp}
                      updateAble={isUpdateAble}
                      checked={baseInf?.brkfInYn === "N"}
                    />
                  </div>
                </li>
                <li>
                  <label htmlFor="">{t("lbl_uyn")}</label>
                  <div className="flex">
                    <Radio
                      label={t("uyn_y")}
                      id={"Y"}
                      name={"uynOp"}
                      dataTyp={dataTyp}
                      updateAble={isUpdateAble}
                      checked={baseInf ? baseInf?.uyn === "Y" : true}
                    />
                    <Radio
                      label={t("uyn_n")}
                      id={"N"}
                      name={"uynOp"}
                      dataTyp={dataTyp}
                      updateAble={isUpdateAble}
                      checked={baseInf?.uyn === "N"}
                    />
                  </div>
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}
